import React from 'react';

export const STATUS_META = {
  open: { label: 'Open', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
  in_progress: { label: 'In progress', cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  ready: { label: 'Ready', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  invoiced: { label: 'Invoiced', cls: 'btn-ink' },
  cancelled: { label: 'Cancelled', cls: 'bg-slate-100 text-slate-500 border-slate-200 line-through' },
};

export const FLOW = ['open', 'in_progress', 'ready', 'invoiced'];

export const StatusPill = ({ status, testid }) => {
  const meta = STATUS_META[status] || STATUS_META.open;
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${meta.cls}`} data-testid={testid}>
      {meta.label}
    </span>
  );
};

export const vehicleLabel = (v) => [v?.registration_number, [v?.make, v?.model].filter(Boolean).join(' ')].filter(Boolean).join(' · ');

export const lineTotal = (it) => (Number(it.qty) || 0) * (Number(it.rate) || 0);
